import requestAnimationFrame from './requestAnimationFrame';
export default (function (callback) {
  var isUpdating = false;
  var updateFrame = function updateFrame() {
    callback();
    isUpdating = false;
  };
  return function () {
    if (isUpdating) return;
    isUpdating = true;
    requestAnimationFrame(updateFrame);
  };
});